<template>
  <div>
    <!-- System table -->
    <div class="card"
         qid="third-party-receivers-section"
         v-if="showTable"
         id="update_third_party_receivers"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="tp-receiver-table-title" v-if="!showOnTask">
                {{ $t('activities.third_party.tp_receivers_title') }}
              </h5>

              <span v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_third_party_receivers')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_third_party_receivers')"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_third_party_receivers')">
                  <GuideButton :guide="getGuide('update_third_party_receivers')"></GuideButton>
                </span>
              </span>
            </div>

          </div>
          <div class="col-sm-6 text-right">
            <span v-if="isGranted(permissions.THIRD_PARTY_CREATE)" qid="third-party-tp-receiver-create-button">
              <ThirdPartyCreateForm></ThirdPartyCreateForm>
            </span>
            <span class="btn btn-success pl-3 pr-3 cursor-pointer"
                  @click="showCreateSModal()"
                  v-if="isGranted([permissions.ACTIVITY_THIRD_PARTY_RECEIVER_CREATE, permissions.ACTIVITY_THIRD_PARTY_RECEIVER_CREATE_OWN], activity)"
                  qid="activity-tp-receiver-create-button"
            >
              <font-awesome-icon icon="plus"/> {{ $t('activities.third_party.create_button') }}
            </span>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
          <tr>
            <th scope="col">
              {{ $t('activities.third_party.table.name') }}
            </th>
            <th scope="col">
              {{ $t('activities.third_party.table.processing_role') }}
            </th>
            <th scope="col">
              {{ $t('activities.third_party.table.data_objects') }}
            </th>
            <th scope="col">
              {{ $t('system.last_updated') }}
            </th>
            <th width="280"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="object in sTableItems">
              <td style="line-height: 1.8;">
                <span class="cursor-pointer mr-2 mt-2 float-left" @click="openViewVendorModal(object.third_party.vendors[0])">
                  <Avatar :object="object.third_party.vendors[0]" size="xs"></Avatar>
                </span>
                <span v-if="object.third_party && object.third_party.name && !isOwner(object.third_party)"
                      qid="tp-receiver-name"
                      class="float-left"
                >
                  {{ object.third_party.name }}
                  <br style="height:0px;"/>
                  <span class="text-muted" v-for="(vendor, index) in object.third_party.vendors">
                    {{ vendor.name }}
                    <span v-if="index < object.third_party.vendors.length - 1">, </span>
                  </span>
                </span>

                <router-link
                    v-if="object.third_party && object.third_party.name && isOwner(object.third_party)"
                    :to="{ name: 'contracts.view', params: { slug: object.third_party.slug, client: object.third_party.client }}"
                    qid="tp-view-page-link"
                >
                  {{object.third_party.name}}
                </router-link>
                <br style="height:0px;" v-if="object.third_party && object.third_party.name && isOwner(object.third_party)"/>
                <span class="text-muted" v-for="(vendor, index) in object.third_party.vendors" v-if="object.third_party && object.third_party.name && isOwner(object.third_party)">
                  {{ vendor.name }}
                  <span v-if="index < object.third_party.vendors.length - 1">, </span>
                </span>
              </td>
              <td>
                <span v-if="object.processing_role" class="text-normal">
                  <span v-if="object.processing_role == 'Data processor'">
                    <font-awesome-icon icon="microchip" class="mr-2"/>
                  </span>
                  <span v-if="object.processing_role == 'Data controller'">
                    <font-awesome-icon icon="joystick" class="mr-2"/>
                  </span>
                  <span v-if="object.processing_role == 'Joint controller'">
                    <font-awesome-icon icon="handshake" class="mr-2"/>
                  </span>
                  {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(object.processing_role)) }}
                </span>
                <span class="text-muted cursor-pointer btn btn-sm btn-link mr-2 ml-2"
                      qid="edit-activity-modal"
                      @click="showEditProcessingRoleModal(object)"
                      v-if="isGranted([permissions.ACTIVITY_THIRD_PARTY_RECEIVER_EDIT, permissions.ACTIVITY_THIRD_PARTY_RECEIVER_EDIT_OWN], activity)"
                >
                  <font-awesome-icon icon="pen" />
                </span>
              </td>
              <td>
                <span @click="showDataObjectsModal(object, item)"
                      class="mr-1 cursor-pointer btn btn-link p-0 cursor-pointer"
                      v-for="item in getUniqueCategories(object)"
                >
                  <span class="badge">
                    {{ $t('classification.' + $options.filters.slugify(item)) }}
                  </span>
                </span>
              </td>
              <td>
                <span class="text-normal">
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td align="right">
                <span class="btn btn-secondary"
                        v-if="isGranted([permissions.ACTIVITY_THIRD_PARTY_RECEIVER_EDIT, permissions.ACTIVITY_THIRD_PARTY_RECEIVER_EDIT_OWN], activity)"
                        qid="system-copy-link"
                        @click="showDataMappingModal(object)"
                >
                  {{ $t('activities.tab.data_mapping') }}
                </span>
                <span v-if="object.third_party && object.third_party.name"
                      @click="openViewTPModal(object)"
                      qid="tp-receiver-name-link"
                      class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </span>

                <span class="btn btn-delete"
                        qid="delete-activity-modal"
                        @click="showSConfirmDeleteModal(object)"
                        v-if="isGranted([permissions.ACTIVITY_THIRD_PARTY_RECEIVER_EDIT, permissions.ACTIVITY_THIRD_PARTY_RECEIVER_EDIT_OWN], activity)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!sLoading && !sTableItems.length" qid="no-results-row-tpr" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


    <!-- Delete third_party modal template -->
    <b-modal ref="delete-ac" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-ac-title">
          {{ $t('activities.third_party.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.third_party.delete.description') }}
        <span v-if="itemToDelete.third_party">{{ itemToDelete.third_party.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.third_party.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideSConfirmDeleteModal"
                  qid="delete-ac-cancel-button"
        >
          {{ $t('activities.third_party.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteS(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-ac-submit-button"
        >
          {{ $t('activities.third_party.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Edit third_party modal -->
    <b-modal ref="edit-third-party"
             hide-footer
             @hide="hideEditSModal"
             size="md"
    >
      <div class="d-block text-center">
        <h4 qid="update-tp-title">
          {{ $t('activities.third_party.update.title_receivers') }}
          <span v-if="itemObject.third_party">'{{ itemObject.third_party.name }}'</span>
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="sEditFormSubmit" qid="create-p-form">
        <div class="form-container">
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditSModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('activities.third_party.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('activities.third_party.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Data mapping modal -->
    <b-modal ref="data-mapping"
             @hide="hideDataMappingModal"
             modal-class="task-modal mapping-modal"
    >

      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideDataMappingModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center">
            {{ $t('activities.third_party.mapping_title') }}
            <span v-if="itemObject.third_party">
              <font-awesome-icon icon="exchange-alt" />
              {{ itemObject.third_party.vendors[0].name }}
            </span> -
            <span v-if="itemObject.third_party && !isOwner(itemObject.third_party)">
              {{ itemObject.third_party.name }}
            </span>
            <router-link
                :to="{ name: 'contracts.view', params: { slug: itemObject.third_party.slug }}"
                qid="s-view-page-link"
                v-if="itemObject.third_party && isOwner(itemObject.third_party)"
            >
              {{ itemObject.third_party.name }}
            </router-link>
          </h5>
          <div class="row mt-2 pt-4 pb-1" v-if="getGuide('data_mapping')">
            <div class="col-sm-12">
              <b-form-group>
                <div class="">
                  <div v-if="getGuide('data_mapping')" class="mb-2">
                    <GuideButton :guide="getGuide('data_mapping')"></GuideButton>
                  </div>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="dataMappingFormSubmit" qid="create-ac-form">
        <div>
          <div class="mb-4 mt-3">
            <span class="btn btn-secondary cursor-pointer" @click="showCopyFromModal(itemObject)">
              <font-awesome-icon icon="plus"/>
              {{ $t('activities.system.copy.system_label') }}
            </span>
            <span class="btn btn-secondary cursor-pointer" @click="toggleSearch()">
              <font-awesome-icon icon="search"/>
              {{ $t('system.show_hide_search') }}
            </span>
          </div>
          <div class="row mb-3" v-if="showSearch">
            <div class="col">
              <b-form-group>
                <label qid="edit-lb-category-label">
                  {{ $t('activities.system.create.data_point_label') }}
                </label>
                <div>
                  <b-form-input
                    type="text"
                    v-model="keywordValue"
                    qid="search-do-input"
                    v-on:input="debounceInput"
                    :placeholder="$t('activities.third_party.data_objects.search_placeholder')"
                  ></b-form-input>
                </div>
              </b-form-group>
            </div>
            <!-- <div class="col-1">

            </div>
            <div class="col">
              <b-form-group>
                <label qid="edit-s-data-label">
                  {{ $t('activities.system.create.data_label') }}
                </label>
                <div>
                  <b-form-input
                    type="text"
                    v-model="keywordFilterValue"
                    qid="search-do-input"
                    v-on:input="filterSelectedData"
                    :placeholder="$t('activities.third_party.data_objects.filter_placeholder')"
                  ></b-form-input>
                </div>
              </b-form-group>
            </div> -->
          </div>
          <div class="row">
            <div class="col">
              <!-- <div>
                <label class="float-right cursor-pointer ml-3"
                       @click="unselectAll"
                       qid="system-unselect-button"
                >
                  {{ $t('system.unselect_all') }}
                </label>
                <label class="float-right cursor-pointer"
                       @click="selectAll"
                       qid="system-select-button"
                >
                  {{ $t('system.select_all') }}
                </label>
              </div>
              <br> -->

              <div @click="showRelatedFunction()" class="mb-1 cursor-pointer">
                <font-awesome-icon :icon="['far', 'square']" style="color:#BCDAD4;margin-bottom:1px;" v-if="!showOnlyRelated"/>
                <font-awesome-icon icon="check-square" style="color:#2DBA9B;margin-bottom:1px;" v-if="showOnlyRelated" />
                {{ $t('system.show_only_related_data') }}
                (<span id="related-number" style="display:inline-block;text-align:center;">{{ selectedDataObjects.length }}</span>)
              </div>
              <div class="form-control scrollable-height-430 pt-3"
                   qid="tp-source-data-objects"
              >
                <div>
                  <div class="" v-for="(item, index) in DOItems">
                    <div class="data-object-div" :id="'data-object-' + index"
                         @click="selectDataObject(index, item)"
                         :class="{'data-object-div-selected': item.selected}"
                    >
                      <b-popover
                          :target="'data-object-' + index"
                          boundary="viewport"
                          triggers="hover"
                          placement="top"
                          :delay="{ show: 500, hide: 0 }"
                      >
                        <div v-if="item.name" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.name') }}:
                          </span>
                          <br>
                          {{ item.name }}
                          <br>
                        </div>

                        <div v-if="item.description" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.description') }}:
                          </span>
                          <br>
                          {{ item.description | truncate(200)}}
                          <br>
                        </div>

                        <div v-if="item.category" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.category') }}:
                          </span>
                          <br>
                          <span v-if="item.category" class="mr-3">
                            <font-awesome-icon icon="shapes" class="mr-1" />
                            {{ item.category }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.classification" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.classification') }}:
                          </span>
                          <br>
                          <span class="badge pl-0 mr-3">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="item.classification == 'N/A'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.classification == 'Generic art. 6'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.classification == 'National identification number art. 87'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.classification == 'Sensitive art. 9' || item.classification == 'Criminal art. 10'"/>
                            {{ $t('classification.' + $options.filters.slugify(item.classification)) }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.business_classification" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.business_classification') }}:
                          </span>
                          <br>
                          <span class="badge pl-0 mr-3" v-if="item.business_classification">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.business_classification == 'Unclassified'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.business_classification == 'Confidential'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.business_classification == 'Top secret' || item.business_classification == 'Secret'"/>
                            {{ $t('classification.' + $options.filters.slugify(item.business_classification)) }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.tags_translated && item.tags_translated.length">
                          <span class="text-bold">
                            {{ $t('processes.table.tags') }}:
                          </span>
                          <br>
                          <span v-for="tag in item.tags_translated" qid="p-tags-list">
                            <span class="badge" :title="tag.name_translated">
                              <font-awesome-icon icon="tag"/>
                              {{ tag.name_translated }}
                            </span>
                          </span>
                          <br>
                        </div>

                      </b-popover>

                      <font-awesome-icon :icon="['far', 'square']" style="color:#BCDAD4;" v-if="!item.selected" class="mr-2"/>
                      <font-awesome-icon icon="check-square" style="color:#2DBA9B;" v-if="item.selected" class="mr-2"/>
                      <!-- <b-form-checkbox
                        v-model="item.selected"
                        name="checkbox-disable"
                        :value="true"
                        :unchecked-value="false"
                        style="display:inline;pointer-events:none;"
                      ></b-form-checkbox> -->
                      <span>{{ item.name | truncate(20)}}</span>
                    </div>
                  </div>
                  <!-- <div class="table-item-div cursor-pointer"
                       v-for="(item, index) in DOItems"
                       @click="selectDataObject(index, item)"
                       :class="{'table-item-div-selected': item.selected}"
                  >
                    <div class="text-bold">
                      {{ item.name }}
                    </div>
                    <div>
                      <span v-if="item.category" class="mr-3">
                        <font-awesome-icon icon="shapes" class="mr-1" />
                        {{ item.category }}
                      </span>
                      <span class="mr-3">
                        <span v-if="item.tags_translated && item.tags_translated.length" qid="activity-tags-list">
                          <span v-for="tag in getReducedTags(item.tags_translated)" :title="tag.name_translated" qid="p-tags-list">
                            <span class="badge" :title="tag.name_translated">
                              <font-awesome-icon icon="tag"/>
                              {{ tag.name_translated | truncate(35) }}
                            </span>
                          </span>
                          <span v-if="item.tags_translated.length > 1"
                                class="badge cursor-pointer"
                                @click="openTagsModal(item, $event)"
                          >
                            <font-awesome-icon icon="tags"/>
                            + {{ item.tags_translated.length - 1 }}
                          </span>
                        </span>
                      </span>
                      <span class="badge pl-0 mr-3">
                        <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="item.classification == 'N/A'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.classification == 'Generic art. 6'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.classification == 'National identification number art. 87'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.classification == 'Sensitive art. 9' || item.classification == 'Criminal art. 10'"/>
                        {{ $t('classification.' + $options.filters.slugify(item.classification)) }}
                      </span>
                      <span class="badge pl-0 mr-3" v-if="item.business_classification">
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.business_classification == 'Unclassified'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.business_classification == 'Confidential'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.business_classification == 'Top secret' || item.business_classification == 'Secret'"/>
                        {{ $t('classification.' + $options.filters.slugify(item.business_classification)) }}
                      </span>
                    </div>
                  </div> -->
                  <div class="text-center table-item-div" v-if="!loading && !DOItems.length">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </div>
                </div>
              </div>
              <!-- <div class="text-muted mt-2 mb-3">
                {{ $t('activities.system.create.tip_add_label') }}
              </div> -->
            </div>
            <!-- <div class="col-1">
              <b-button class="mt-200 btn-block"
                        variant="success"
                        @click="addData"
                        size="sm"
                        qid="system-select-button"
              >
                {{ $t('system.add') }} >
              </b-button>
            </div> -->
            <!-- <div class="col">
              <div>
                <label class="float-right cursor-pointer ml-3"
                       @click="unrelateAll"
                       qid="system-unselect-button"
                >
                  {{ $t('system.unselect_all') }}
                </label>
                <label class="float-right cursor-pointer"
                       @click="relateAll"
                       qid="system-select-button"
                >
                  {{ $t('system.select_all') }}
                </label>
                <br>
                <div class="form-control scrollable-height-430" qid="tp-source-data-objects">
                  <div>
                    <div class="table-item-div cursor-pointer"
                         v-for="(itemDO, index) in allDataObjectsFiltered"
                         @click="handleDO(index, itemDO)"
                         :class="{'table-item-div-selected': itemDO.related}"
                    >
                      <div class="text-bold">
                        {{ itemDO.name }}
                      </div>
                      <div>
                        <span v-if="itemDO.category" class="mr-3">
                          <font-awesome-icon icon="shapes" class="mr-1" />
                          {{ itemDO.category }}
                        </span>
                        <span class="mr-3">
                          <span v-if="itemDO.tags_translated && itemDO.tags_translated.length" qid="activity-tags-list">
                            <span v-for="tag in getReducedTags(itemDO.tags_translated)" :title="tag.name_translated" qid="p-tags-list">
                              <span class="badge" :title="tag.name_translated">
                                <font-awesome-icon icon="tag"/>
                                {{ tag.name_translated | truncate(35) }}
                              </span>
                            </span>
                            <span v-if="itemDO.tags_translated.length > 1"
                                  class="badge cursor-pointer"
                                  @click="openTagsModal(itemDO, $event)"
                            >
                              <font-awesome-icon icon="tags"/>
                              + {{ itemDO.tags_translated.length - 1 }}
                            </span>
                          </span>
                        </span>
                        <span class="badge pl-0 mr-3">
                          <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="itemDO.classification == 'N/A'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="itemDO.classification == 'Generic art. 6'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="itemDO.classification == 'National identification number art. 87'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="itemDO.classification == 'Sensitive art. 9' || itemDO.classification == 'Criminal art. 10'"/>
                          {{ $t('classification.' + $options.filters.slugify(itemDO.classification)) }}
                        </span>
                        <span class="badge pl-0 mr-3" v-if="itemDO.business_classification">
                          <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="itemDO.business_classification == 'Unclassified'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="itemDO.business_classification == 'Confidential'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="itemDO.business_classification == 'Top secret' || itemDO.business_classification == 'Secret'"/>
                          {{ $t('classification.' + $options.filters.slugify(itemDO.business_classification)) }}
                        </span>
                      </div>
                    </div>
                    <div class="text-center table-item-div" v-if="!allDataObjectsFiltered.length">
                      <h5 class="mt-3">
                        {{ $t('system.no_results') }}
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="text-muted mt-2">
                  {{ $t('activities.system.create.tip_label') }}
                </div>
                <div>
                  <span class="color-primary mr-2 legend-icon-container">
                    <span class="legend legend-primary"></span>
                  </span>
                  <span>{{ $t('system.related') }}</span>
                  <span class="color-white ml-4 mr-2 legend-icon-container">
                    <span class="legend legend-white"></span>
                  </span>
                  <span>{{ $t('system.not_related') }}</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
                <div v-if="isGranted(permissions.DATA_OBJECT_CREATE)"
                     qid="data-object-system-create-button"
                     class="text-left mt-2"
                >
                  <DataObjectCreateForm @updated="loadDO()"></DataObjectCreateForm>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-2 mb-2"
                            variant="secondary"
                            @click="mappingHide"
                            qid="create-ac-cancel-button"
                  >
                    {{ $t('activities.third_party.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="mt-2 mb-2 ml-3 mr-0"
                            :disabled="buttonDisabled"
                            variant="success"
                            @click="dataMappingFormSubmit()"
                            qid="create-ac-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('activities.third_party.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>



    <!-- Copy from modal -->
    <b-modal ref="copy-from"
             @hide="hideCopyFromModal"
             size="sm"
             modal-class="task-modal mapping-modal"
    >

      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="copyHide" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center">
            {{ $t('activities.system.copy.modal_title') }}
          </h5>
          <div class="row mt-2 pt-4 pb-1" v-if="getGuide('copy_dataflow')">
            <div class="col-sm-12">
              <b-form-group>
                <div class="">
                  <div v-if="getGuide('copy_dataflow')" class="mb-2">
                    <GuideButton :guide="getGuide('copy_dataflow')"></GuideButton>
                  </div>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullCopyGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullCopyGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullCopyGuideDescription=!showFullCopyGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullCopyGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullCopyGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>

      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="copyFromFormSubmit" qid="create-ac-form">
        <div>
          <div class="row mb-3">
            <div class="col">
              <b-form-group>
                <label qid="create-ac-pg-label">
                  {{ $t('activities.system.copy.system_label') }}
                </label>
                <multiselect
                    v-model="selectedTP"
                    :options="copyOptions"
                    :placeholder="$t('activities.system.copy.system_placeholder')"
                    label="name"
                    group-values="items"
                    group-label="group"
                    :group-select="false"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    @select="selectCopyItem"
                    @remove="deselectCopyItem"
                    track-by="track_name"
                    qid="create-ac-form-ac"
                ></multiselect>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col">

              <div>
                <label class="float-right cursor-pointer"
                       @click="selectAllCopy"
                       qid="system-select-button"
                >
                  {{ $t('system.select_all') }}
                </label>
              </div>
              <br>

              <div class="form-control scrollable-height-430 pt-3"
                   qid="tp-source-data-objects"
              >
                <div>
                  <div class="" v-for="(item, index) in copyItems">
                    <div class="data-object-div" :id="'copy-object-' + index"
                         @click="selectCopyObject(index, item)"
                         :class="{'data-object-div-selected': item.selected}"
                    >
                      <b-popover
                          :target="'copy-object-' + index"
                          boundary="viewport"
                          triggers="hover"
                          placement="top"
                          :delay="{ show: 500, hide: 0 }"
                      >
                        <div v-if="item.name" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.name') }}:
                          </span>
                          <br>
                          {{ item.name }}
                          <br>
                        </div>

                        <div v-if="item.description" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.description') }}:
                          </span>
                          <br>
                          {{ item.description | truncate(200)}}
                          <br>
                        </div>

                        <div v-if="item.category" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.category') }}:
                          </span>
                          <br>
                          <span v-if="item.category" class="mr-3">
                            <font-awesome-icon icon="shapes" class="mr-1" />
                            {{ item.category }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.classification" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.classification') }}:
                          </span>
                          <br>
                          <span class="badge pl-0 mr-3">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="item.classification == 'N/A'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.classification == 'Generic art. 6'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.classification == 'National identification number art. 87'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.classification == 'Sensitive art. 9' || item.classification == 'Criminal art. 10'"/>
                            {{ $t('classification.' + $options.filters.slugify(item.classification)) }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.business_classification" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.business_classification') }}:
                          </span>
                          <br>
                          <span class="badge pl-0 mr-3" v-if="item.business_classification">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.business_classification == 'Unclassified'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.business_classification == 'Confidential'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.business_classification == 'Top secret' || item.business_classification == 'Secret'"/>
                            {{ $t('classification.' + $options.filters.slugify(item.business_classification)) }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.tags_translated && item.tags_translated.length">
                          <span class="text-bold">
                            {{ $t('processes.table.tags') }}:
                          </span>
                          <br>
                          <span v-for="tag in item.tags_translated" qid="p-tags-list">
                            <span class="badge" :title="tag.name_translated">
                              <font-awesome-icon icon="tag"/>
                              {{ tag.name_translated }}
                            </span>
                          </span>
                          <br>
                        </div>
                      </b-popover>

                      <font-awesome-icon :icon="['far', 'square']" style="color:#BCDAD4;" v-if="!item.selected" class="mr-2"/>
                      <font-awesome-icon icon="check-square" style="color:#2DBA9B;" v-if="item.selected" class="mr-2"/>
                      <!-- <b-form-checkbox
                        v-model="item.selected"
                        name="checkbox-disable"
                        :value="true"
                        :unchecked-value="false"
                        style="display:inline;pointer-events:none;"
                      ></b-form-checkbox> -->
                      <span>{{ item.name | truncate(15)}}</span>
                    </div>
                  </div>
                  <div class="text-center table-item-div" v-if="!loading && !copyItems.length">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-2 mb-2"
                            variant="secondary"
                            @click="copyHide"
                            qid="create-ac-cancel-button"
                  >
                    {{ $t('activities.third_party.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="mt-2 mb-2 ml-3 mr-0"
                            :disabled="buttonDisabled"
                            variant="success"
                            @click="copyFromFormSubmit()"
                            qid="create-ac-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('activities.third_party.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </template>
    </b-modal>



    <!-- Add new third_party modal -->
    <b-modal ref="add-third-party" hide-footer @hide="hideCreateSModal">
      <div class="d-block text-center">
        <h4 qid="add-ac-title">
          {{ $t('activities.third_party.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="addThirdPartyFormSubmit" qid="create-ac-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-ac-pg-label">
              {{ $t('activities.third_party.create.vendor_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="selectedVendor"
                :options="vendors"
                :placeholder="$t('activities.third_party.create.vendor_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadVendors"
                track-by="slug"
                @select="reloadTP"
                @remove="reloadTPWithoutVendor"
                qid="create-ac-form-ac"
            >
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="singleLabel" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>
          <b-form-group v-if="selectedVendor && selectedVendor.id">
            <label qid="create-ac-pg-label">
              {{ $t('activities.third_party.create.third_party_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="selectedTP"
                :options="sItems"
                :placeholder="$t('activities.third_party.create.third_party_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadTP"
                track-by="slug"
                qid="create-ac-form-ac"
            ></multiselect>
          </b-form-group>
          <div v-if="selectedTP && selectedTP.description"
               class="text-center mb-3 mt-4"
          >
            <span class="cursor-pointer">
              <span class="mr-2"
                    @click="showSDescription = !showSDescription"
                    qid="expand-tp-description"
              >
                {{$t('activities.third_party.create.third_party_description_expand')}}
              </span>
              <font-awesome-icon icon="chevron-down" v-if="!showSDescription"/>
              <font-awesome-icon icon="chevron-up" v-if="showSDescription"/>
            </span>
          </div>
          <div v-if="selectedTP && selectedTP.description && showSDescription" class="mb-4 mt-2">
            <span class="text-formatted">
              {{ selectedTP.description }}
            </span>
          </div>
          <b-form-group v-if="selectedVendor && selectedVendor.id">
            <label qid="create-ac-pg-label">
              {{ $t('activities.processing_role.title') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="processingRole"
                :options="options"
                :placeholder="$t('activities.processing_role.pr_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="name"
                qid="processing-role-dropdown"
            >
              <template slot="option" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
              <template slot="singleLabel" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateSModal"
                    qid="create-ac-cancel-button"
          >
            {{ $t('activities.third_party.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-ac-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('activities.third_party.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Show data objects modal -->
    <b-modal ref="view-data-objects" hide-footer @hide="hideDataObjectsModal">
      <div class="d-block text-center">
        <h4 qid="delete-tp-title">
          {{ $t('maintenance.third_parties.data_objects.title') }}
        </h4>
      </div>
      <div class="mt-5" v-if="filteredDataObjects && filteredDataObjects.length">
        <div v-for="dataObject in filteredDataObjects">
          <div class="mb-4">
            <span class="badge badge-info float-right">
              {{ $t('classification.' + $options.filters.slugify(dataObject.classification )) }}
            </span>
            <span>{{ dataObject.name }}</span>
          </div>
        </div>
      </div>
      <div class="float-right">
        <b-button class="mt-3"
                  variant="success"
                  @click="hideDataObjectsModal"
                  qid="delete-tp-cancel-button"
        >
          {{ $t('maintenance.third_parties.data_objects.close') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Edit processing role modal -->
    <b-modal ref="edit-processing-role" hide-footer @hide="hideEditProcessingRoleModal">
      <div class="d-block text-center">
        <h4 qid="delete-tp-title">
          {{ $t('maintenance.third_parties.processing_role_modal_title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editProcessingRoleFormSubmit" qid="create-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-lb-category-label">
              {{ $t('activities.third_party.create.pr_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="processingRole"
                :options="options"
                :placeholder="$t('activities.third_party.create.pr_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="name"
                qid="edit-tp-form-inspection"
            >
              <template slot="option" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
              <template slot="singleLabel" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditProcessingRoleModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('projects.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('projects.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <ThirdPartyViewModal
        :object="selectedTP"
        :showModal="viewTPModal"
        @closeViewModal="handleCloseViewTPModal"
        v-if="selectedTP"
        :active="showDocuments"
        :attachments="showAttachments"
    ></ThirdPartyViewModal>

    <VendorViewModal
        :object="vendorToView"
        :showModal="viewVendorModal"
        @closeViewModal="handleCloseViewVendorModal"
    ></VendorViewModal>

    <ShowMoreModal
        :items="selectedItem.tags_translated"
        :show="showTagsModal"
        @closeViewModal="closeTagsModal"
        type="tags"
    ></ShowMoreModal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import roleCheck from "@/util/ACL/roleCheck"
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import DataObjectCreateForm from '@/views/DataObjects/DataObjectCreateForm.vue';
  import ThirdPartyCreateForm from '@/views/ThirdParty/ThirdPartyCreateForm.vue';
  import ThirdPartyViewModal from '@/views/Systems/ThirdPartyViewModal.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import VendorViewModal from '@/views/ThirdParty/VendorViewModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';


  export default {
    name: 'ThirdPartyReceiversTable',
    data: function() {
      return {
        sForm: {
          processing_role: '',
          data_objects: [],
          links: []
        },

        activity: {},
        // Systems
        sTableItems: [],
        selectedTPSort: '',
        selectedTPDirection: '',
        sItems: [],
        sLoading: true,
        loading: true,
        sValidationShow: false,
        updateValidationList: false,

        // categories
        categoryItems: [],
        categoryInput: '',
        selectedCategory: [],

        copyOptions: [
          {
            group: this.$t('activities.system.copy.general_label'),
            items: []
          },
          {
            group: this.$t('activities.system.copy.systems_label'),
            items: []
          },
          {
            group: this.$t('activities.system.copy.sources_label'),
            items: []
          },
          {
            group: this.$t('activities.system.copy.receivers_label'),
            items: []
          }
        ],

        // Data objects
        allDataObjects: [],
        allDataObjectsFiltered: [],
        dataObjects: [],
        systemDataObjects: [],
        newDataObjects: [],
        DOItems: [],
        selectedDataObjects: [],
        selectedCopyObjects: [],
        copyItems: [],
        availableDataObjects: [],

        // Third parties
        selectedTP: [],
        copyThirdPartyItems: [],
        viewTPModal: false,
        vendors: [],
        selectedVendor: [],
        selectedItem: {},
        showTagsModal: false,

        error: '',
        rules_followed: '',
        loadingItems: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        showSDescription: false,
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        processingRole: [],
        options: [
          { name: this.$t('activities.processing_role.data_processor_label'), value: 'Data processor' },
          { name: this.$t('activities.processing_role.data_controller_label'), value: 'Data controller' },
          { name: this.$t('activities.processing_role.joint_controller_label'), value: 'Joint controller' }
        ],
        buttonDisabled: false,
        keywordValue: '',
        keywordFilterValue: '',
        showSelectionTable: false,
        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        showAttachments: false,
        filteredDataObjects: [],
        showTable: false,
        hideSearch: false,
        showMore: false,
        page: 1,
        myGuides: [],
        myTasks: [],
        vendorToView: {},
        showFullGuideDescription: false,
        showFullCopyGuideDescription: false,
        showCopyDropdown: false,
        showSearch: false,
        showOnlyRelated: false,
        wpGuide: {},
        viewVendorModal: false
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      DataObjectCreateForm,
      ThirdPartyCreateForm,
      ThirdPartyViewModal,
      UpdateSingleTaskModal,
      VendorViewModal,
      GuideButton,
      ShowMoreModal
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getFiles() {
        return this.selectedFiles
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      },
      object: function (newValue) {
        if (newValue && newValue.id) {
          this.activity = newValue
          this.showTable = true;
          this.loadTasks('update_third_party_receivers');
          this.loadThirdParties();
        }
      },
      showOnlyRelated: function (newValue) {
        if (newValue) {
          this.keywordValue = ''
          this.selectedDataObjects = _.sortBy(this.selectedDataObjects, 'name');
          this.DOItems =  _.cloneDeep(this.selectedDataObjects);
        } else {
          this.loadDO(this.keywordValue)
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.activity.id && this.$store.state.updatedObject.who_am_i == this.activity.who_am_i) {
              this.activity = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_third_party_receivers')
        }
      },
    },
    methods: {
      debounceInput: _.debounce(function() {
        let self = this;
        if (this.keywordValue && this.keywordValue.length) {
          this.showOnlyRelated = false;
        }

        this.loadDO(this.keywordValue)

      }, 400),
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      toggleSearch() {
        this.showSearch = !this.showSearch
      },
      showRelatedFunction() {
        this.showOnlyRelated = !this.showOnlyRelated
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      openTagsModal(object, evt) {
        this.selectedItem = object
        this.showTagsModal = true
        evt.stopPropagation();
      },
      closeTagsModal() {
        this.selectedItem = {}
        this.showTagsModal = false
      },
      getReducedTags(tags) {
        let reducedTags = []
        if (tags.length > 1) {
          reducedTags = _.cloneDeep(tags);
          reducedTags = reducedTags.slice(0, 1);
        } else {
          reducedTags = tags;
        }
        return reducedTags;
      },
      reloadContent() {
        this.loadTasks('update_third_party_receivers');
        this.loadThirdParties();
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.activity.who_am_i,
              model_id: this.activity.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      setValidation(object) {
        this.validation = object
        this.updateValidationList = false;
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      openViewVendorModal(object) {
        this.vendorToView = object
        this.viewVendorModal = true
      },
      handleCloseViewVendorModal () {
        this.vendorToView = []
        this.viewVendorModal = false;
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Activity' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Activity',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + self.myGuides[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.sForm.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.sForm.links.splice(index, 1);
      },
      addData() {
        let self = this;
        _.forEach(this.DOItems, function (item) {
          if (item.selected) {
            self.updateDOList(item)
          }
        })
        this.unselectAll()
        if (this.selectedTP && this.selectedTP.id) {
          this.selectCopyItem(this.selectedTP)
        } else {
          this.loadDO()
        }
      },
      filterSelectedData() {
        let self = this;
        this.allDataObjectsFiltered = [];
        if (self.keywordFilterValue) {
          _.forEach(this.allDataObjects, function (item) {
            if (
              item.name.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1 ||
              (item.category && item.category.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1) ||
              (item.classification && item.classification.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1)
            ) {
              self.allDataObjectsFiltered.push(item)
            }
          })
        } else {
          this.allDataObjectsFiltered = _.cloneDeep(this.allDataObjects);
        }
      },
      resetFields() {
        this.selectedRC = null
        this.selectedP = null
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      setValidation(object) {
        this.validation = object
      },
      selectCopyItem(object) {
        this.showMore = false;
        this.selectedCopyObjects = []
        let self = this
        this.copyItems = []
        let results = object.data_objects
        _.forEach(results, function (item) {
          if (_.findIndex(self.allDataObjects, function(o) { return o.id == item.id }) == -1) {
            item.selected = false
            self.copyItems.push(item)
          } else {
            let index = _.findIndex(self.allDataObjects, function(o) { return o.id == item.id })
            if ( index >= 0) {
              if (!self.allDataObjects[index].related) {
                item.selected = false
                self.copyItems.push(item)
              }
            }
          }
        })
      },
      deselectCopyItem(object) {
        this.loadDO();
        this.hideSearch = false;
      },
      showDataObjectsModal(object, classification) {
        let self = this;
        this.selectedTP = object

        if (!object) {
          this.availableDataObjects = [];
        }

        _.forEach(object.data_objects, function (item) {
          if (item.classification == classification) {
            self.filteredDataObjects.push(item)
          }
        })

        this.$refs['view-data-objects'].show()
      },
      hideDataObjectsModal() {
        this.selectedTP = {}
        this.filteredDataObjects = []
        this.$refs['view-data-objects'].hide()
      },
      getUniqueCategories(object) {
        let categories = []
        // Loop through all data objects in third party
        if (object.data_objects && object.data_objects.length) {
          _.forEach(object.data_objects, function (item) {
            categories.push(item.classification)
          })
          // Return unique array of categories in data objects
          return _.uniq(categories);
        }
      },
      showCreateSModal() {
        this.loadVendors();
        this.processingRole = []
        this.$refs['add-third-party'].show()
      },
      hideCreateSModal() {
        this.error = ''
        this.sForm.links = [];
        this.selectedFiles = [];
        this.selectedTP = []
        this.selectedVendor = []
        this.processingRole = []
        this.loadContent()
        this.$refs['add-third-party'].hide()
      },
      showEditProcessingRoleModal(object) {
        this.itemObject = object

        this.processingRole = []
        if (object.processing_role) {
          this.processingRole = _.find(this.options, function(item) {
            return item.value === object.processing_role;
          });
        }

        this.$refs['edit-processing-role'].show()
      },
      hideEditProcessingRoleModal() {
        this.error = ''
        this.itemObject = []
        this.processingRole = []
        this.loadThirdParties()
        this.$refs['edit-processing-role'].hide()
      },
      editProcessingRoleFormSubmit(evt) {

        let self = this;
        evt.preventDefault();

        this.sForm.processing_role = this.processingRole ? this.processingRole.value : '';

        self.sForm.data_objects = []
        _.forEach(this.itemObject.data_objects, function (dataObject) {
          self.sForm.data_objects.push(dataObject.id)
        })

        if (this.processingRole && this.processingRole.value) {
          this.buttonDisabled = true;
          piincHttp.put('activities/' + this.activity.slug + '/third-party-receivers/' + this.itemObject.id, this.sForm).then(function(response) {
            self.$toastr('success', self.$t('activities.third_party.update.success'))
            self.hideEditProcessingRoleModal()
            self.$emit('updated');
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = ''
          if (!this.processingRole || (this.processingRole && !this.processingRole.value)) {
            this.error +=  ' ' + this.$t('activities.third_party.create.processing_role_error')
          }
        }
      },
      showDataMappingModal(object) {
        let self = this;
        let inArray = false;
        this.itemObject = object
        this.selectedDataObjects = []
        this.sForm.data_objects = [];
        this.availableDataObjects = [];

        _.forEach(object.data_objects, function (dataObject) {
           dataObject.selected = true;
           self.selectedDataObjects.push(dataObject)
        })
        this.selectedDataObjects = _.sortBy(this.selectedDataObjects, 'name');

        this.loadDO();

        this.$refs['data-mapping'].show()
      },
      hideDataMappingModal() {
        this.error = ''
        this.keywordValue = ''
        this.keywordFilterValue = ''
        this.allDataObjects = []
        this.loadThirdParties()
        this.copyThirdPartyItems = []
        this.itemObject = {}
        this.selectedTP = []
        this.hideSearch = false;
        this.$refs['data-mapping'].hide()
      },
      mappingHide() {
        this.$refs['data-mapping'].hide()
      },
      showCopyFromModal(object) {
        let self = this;
        let inArray = false;
        this.itemObject = object
        this.selectedCopyObjects = []
        this.sForm.data_objects = [];
        self.copyOptions[0].items = []
        let item = {}

        if (this.itemObject && this.itemObject.third_party) {
          item.name = this.$t('activities.system.copy.previously_selected_label_third_party')
          item.track_name = this.$t('activities.system.copy.previously_selected_label_third_party')
          item.data_objects = this.itemObject.third_party.data_objects
          self.copyOptions[0].items.push(item)
        }

        piincHttp.get('activities/' + self.activity.slug + '/systems', { params:
          {
            client: self.getClient.slug
          }
        }).then(function(response) {
          self.copyOptions[1].items = []
          _.forEach(response.data, function (item) {
            item.name = item.system.name
            item.track_name = item.system.name + ' - System'
            item.slug = item.system.slug
            self.copyOptions[1].items.push(item)
          })
        }, function() {});

        piincHttp.get('activities/' + this.activity.slug + '/third-party-sources', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.copyOptions[2].items = []
          _.forEach(response.data, function (item) {
            item.name = item.third_party.vendors[0].name + ' - ' + item.third_party.name
            item.track_name = item.third_party.name + ' - ' + item.third_party.name + ' - Third party ' + item.type
            item.slug = item.third_party.slug
            if (self.itemObject.id != item.id) {
              self.copyOptions[2].items.push(item)
            }
          })
        }, function() {});

        piincHttp.get('activities/' + this.activity.slug + '/third-party-receivers', { params:
          {
            client: self.getClient.slug
          }
        }).then(function(response) {
          self.copyOptions[3].items = []
          _.forEach(response.data, function (item) {
            item.name = item.third_party.vendors[0].name + ' - ' + item.third_party.name
            item.track_name = item.third_party.name + ' - ' + item.third_party.name + ' - Third party ' + item.type
            item.slug = item.third_party.slug
            if (self.itemObject.id != item.id) {
              self.copyOptions[3].items.push(item)
            }
          })
        }, function() {});

        this.$refs['copy-from'].show()
      },
      hideCopyFromModal() {
        this.error = ''
        this.keywordValue = ''
        this.copyThirdPartyItems = []
        this.copyItems = []
        this.selectedTP = []
        this.hideSearch = false;
        this.loadDO()
        this.$refs['copy-from'].hide()
      },
      copyHide() {
        this.$refs['copy-from'].hide()
      },
      selectAllCopy() {
        let newDataObjectsArray = []
        let self = this;
        _.forEach(this.copyItems, function (item) {
          item.selected = true;
          newDataObjectsArray.push(item)
          self.selectedCopyObjects.push(item)
        })
        this.copyItems = newDataObjectsArray;
      },
      showSConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-ac'].show()
      },
      hideSConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent()
        this.$refs['delete-ac'].hide()
      },
      handleValidationModalClose() {
        this.updateValidationList = true
        this.loadContent()
      },
      openViewTPModal(object, showDocuments) {
        if (showDocuments) {
          // this.showDocuments = true;
        }
        this.selectedTP = object
        this.viewTPModal = true
      },
      handleCloseViewTPModal () {
        this.showDocuments = false;
        this.selectedTP = []
        this.viewTPModal = false;
      },
      handleDO(index, item, related) {
        let self = this;

        if (item.new_item && item.related && !related) {
          this.removeDataItem(item, related)
        } else {

          if (related == undefined) {
            // Toggle related/not related property
            item.related = item.related ? false : true;
          } else {
            item.related = related
          }

          _.forEach(this.allDataObjects, function (object, objectIndex) {
            if (item.id == object.id) {
              self.$set(self.allDataObjects, objectIndex, item)
            }
          })
          this.$set(this.allDataObjectsFiltered, index, item)

          if (this.selectedTP && this.selectedTP.id) {
            this.selectCopyItem(this.selectedTP)
          } else {
            if (related == undefined) {
              this.loadDO()
            }
          }

        }
      },
      selectDataObject(index, item) {
        // Toggle related/not related property
        item.selected = item.selected ? false : true;
        if (item.selected) {
          let foundItem = false;
          _.forEach(this.selectedDataObjects, function (object) {
            if (object.id == item.id) {
              foundItem = true
            }
          })

          if (!foundItem) {
            this.selectedDataObjects.push(item)
          }
        } else {
          let itemIndex = _.findIndex(this.selectedDataObjects, function(o) { return o.id == item.id; });
          this.selectedDataObjects.splice(itemIndex, 1);
        }

        this.$set(this.DOItems, index, item)
        var element = document.getElementById('related-number');

        element.classList.add("bounce-enter-active");
        setTimeout(function() {
          element.classList.remove("bounce-enter-active");
        }, 700)
      },
      selectCopyObject(index, item) {
        // Toggle related/not related property
        item.selected = item.selected ? false : true;
        if (item.selected) {
          let foundItem = false;
          _.forEach(this.selectedCopyObjects, function (object) {
            if (object.id == item.id) {
              foundItem = true
            }
          })

          if (!foundItem) {
            this.selectedCopyObjects.push(item)
          }
        } else {
          let itemIndex = _.findIndex(this.selectedCopyObjects, function(o) { return o.id == item.id; });
          this.selectedCopyObjects.splice(itemIndex, 1);
        }

        this.$set(this.copyItems, index, item)
      },
      selectAll() {
        let newDataObjectsArray = []
        let self = this;
        _.forEach(this.DOItems, function (item) {
          item.selected = true;
          newDataObjectsArray.push(item)
        })
        this.DOItems = newDataObjectsArray;
      },
      unselectAll() {
        let newDataObjectsArray = []
        let self = this;
        _.forEach(this.DOItems, function (item) {
          item.selected = false;
          newDataObjectsArray.push(item)
        })
        this.DOItems = newDataObjectsArray;
      },
      relateAll() {
        let self = this;
        let newDataObjectsArray = []
        _.forEach(this.allDataObjects, function (item, index) {
          self.handleDO(index, item, true)
        })
        if (this.selectedTP && this.selectedTP.id) {
          this.selectCopyItem(this.selectedTP)
        } else {
          this.loadDO()
        }
      },
      unrelateAll() {
        let self = this;
        let newDataObjectsArray = []

        _.forEach(this.allDataObjects, function (item, index) {
          item.related = false
          self.$set(self.allDataObjects, index, item)
          self.$set(self.allDataObjectsFiltered, index, item)
        })

        _.forEach(this.allDataObjects, function (item, index) {
          if (item && !item.new_item) {
            newDataObjectsArray.push(item)
          }
        })

        this.allDataObjects = newDataObjectsArray
        this.allDataObjectsFiltered = _.cloneDeep(this.allDataObjects);

        if (self.selectedTP && self.selectedTP.id) {
          self.selectCopyItem(self.selectedTP)
        } else {
          self.loadDO()
        }
      },
      updateDOList(selectedOption) {
        let self = this;
        let inArray = false;
        if (this.allDataObjects && this.allDataObjects.length) {
          _.forEach(this.allDataObjects, function (item, index) {
            if (item.id == selectedOption.id) {
              // if item is already in array
              item.related = true;
              self.$set(self.allDataObjects, index, item)
              inArray = true;
              self.allDataObjectsFiltered = _.cloneDeep(self.allDataObjects);
            }
          })
        }
        if (!inArray) {
          // If not in array, push it in array as related
          selectedOption.related = true;
          selectedOption.new_item = true;
          self.allDataObjects.push(selectedOption)
          self.allDataObjectsFiltered = _.cloneDeep(self.allDataObjects);
        }
      },
      removeDataItem(item, related) {

        // find indexes for both arrays
        let filteredIndex = _.findIndex(this.allDataObjectsFiltered, function(o) { return o.id == item.id; });
        let itemIndex = _.findIndex(this.allDataObjects, function(o) { return o.id == item.id; });

        // Remove item from data objects arrays
        this.allDataObjectsFiltered.splice(filteredIndex, 1);
        this.allDataObjects.splice(itemIndex, 1);

        if (this.selectedTP && this.selectedTP.id) {
          this.selectCopyItem(this.selectedTP)
        } else {
          if (related == undefined) {
            this.loadDO()
          }
        }
      },
      showDataObjects(object) {
        this.availableDataObjects = []
        if (object && object.data_objects && object.data_objects.length) {
          this.availableDataObjects = object.data_objects;
        }
      },
      showEditSModal(object) {
        let self = this

        this.itemObject = object;
        this.$refs['edit-third-party'].show()
      },
      hideEditSModal() {
        this.processingRole = []
        this.$refs['edit-third-party'].hide()
      },
      confirmDeleteS(object) {
        let self = this;
        piincHttp.delete('activities/' + this.activity.slug + '/third-party-receivers/' + object.id).then(function() {
          self.hideSConfirmDeleteModal();
          self.loadThirdParties();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('activities.third_party.delete.success'))
        }, function() {});
      },
      addThirdPartyFormSubmit(evt) {
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("third_party_id", this.selectedTP.id);
        formData.append("activity", this.activity.slug);

        if (this.processingRole && this.processingRole.value && this.processingRole.value != '') {
          formData.append("processing_role", this.processingRole.value);
        }

        this.buttonDisabled = true;

        if (this.processingRole && this.processingRole.value && this.selectedTP && this.selectedTP.id) {
          piincHttp.post('/activities/' + this.activity.slug + '/third-party-receivers', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('activities.third_party.create.success'))
            self.hideCreateSModal();
            self.loadThirdParties();
            self.$emit('updated');
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors.third_party_id) {
                self.error += ' ' + error.data.errors.third_party_id[0]
              }
            }
          })
        } else {
          this.error = ''

          if (this.selectedVendor && this.selectedVendor.id) {
            if (!this.selectedTP || (this.selectedTP && !this.selectedTP.id)) {
              this.error +=  ' ' +  this.$t('activities.third_party.create.third_party_error')
            }
            if (!this.processingRole || (this.processingRole && !this.processingRole.value)) {
              this.error +=  ' ' + this.$t('activities.third_party.create.processing_role_error')
            }
          } else {
            this.error = this.$t('activities.third_party.create.vendor_error')
          }

          this.buttonDisabled = false;
        }
      },
      dataMappingFormSubmit(evt) {

        let self = this;
        if (evt) {
          evt.preventDefault();
        }

        self.sForm.data_objects = []
        _.forEach(this.selectedDataObjects, function (dataObject) {
          if (dataObject.selected) {
            self.sForm.data_objects.push(dataObject.id)
          }
        })

        this.buttonDisabled = true;
        piincHttp.put('activities/' + this.activity.slug + '/third-party-receivers/' + this.itemObject.id,
          {
            data_objects: this.sForm.data_objects
          }
        ).then(function(response) {
          self.$toastr('success', self.$t('activities.third_party.update.success'))
          self.$refs['data-mapping'].hide()
          self.copyThirdPartyItems = []
          self.$emit('updated');
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      copyFromFormSubmit(evt) {

        let self = this;
        if (evt) {
          evt.preventDefault();
        }

        _.forEach(this.selectedCopyObjects, function (dataObject) {
          if (_.findIndex(self.selectedDataObjects, function(o) { return o.id == dataObject.id; }) == -1) {
            self.selectedDataObjects.push(dataObject)
          }
        })

        self.$refs['copy-from'].hide()
        self.copyThirdPartyItems = []
      },
      sEditFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        self.sForm.data_objects = []
        _.forEach(this.itemObject.data_objects, function (dataObject) {
          self.sForm.data_objects.push(dataObject.id)
        })

        piincHttp.put('activities/' + this.activity.slug + '/third-party-receivers/' + this.itemObject.id, this.sForm).then(function(response) {
          self.$toastr('success', self.$t('activities.third_party.update.success'))
          self.hideEditSModal();
          self.loadThirdParties();
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.third_party_id) {
              self.error += ' ' + error.data.errors.third_party_id[0]
            }
          }
        })
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      loadContent() {
        let self = this;
        piincHttp.get('activities/' + this.activity.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.activity = response.data;
        }, function() {});
      },
      loadThirdParties() {
        let self = this;

        piincHttp.get('activities/' + this.activity.slug + '/third-party-receivers', { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.sTableItems = response.data;
          self.copyThirdPartyItems = []
          _.forEach(response.data, function (item) {
            item.name = item.third_party.vendors[0].name + ' - ' + item.third_party.name + ' - Third party ' + item.type
            item.slug = item.third_party.slug
            self.copyThirdPartyItems.push(item)
          })
          self.sLoading = false;
        }, function() {});
      },
      loadDO(query, paginate) {
        let self = this;
        this.loading = true
        this.DOItems = []

        piincHttp.get('data-objects', { params:
          {
            client: this.getClient.slug,
            per_page: 200,
            page: this.page,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.DOItems = []
          let foundItem;

          _.forEach(response.data.items, function (item) {
            foundItem = _.find(self.selectedDataObjects, function(object) {
              return object.id == item.id
            });
            if (foundItem && foundItem.id) {
              item.selected = true
            }
            self.DOItems.push(item)
          })

          self.loading = false;
        }, function() {});
      },
      reloadTP(object) {
        this.selectedTP = []
        this.selectedVendor = object;
        this.loadTP()
      },
      reloadTPWithoutVendor(object) {
        this.selectedTP = []
        this.selectedVendor = [];
        this.loadTP()
      },
      loadTP(query) {
        let self = this;
        piincHttp.get('third-parties', { params:
          {
            activity: 1,
            client: this.getClient.slug,
            vendor: this.selectedVendor && this.selectedVendor.id ? this.selectedVendor.id : null,
            relations: 1,
            parent: true,
            per_page: 100,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.sItems = response.data.items
          if (self.sItems && !self.sItems.length && !query) {
            self.sItems.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
          if (self.sItems && self.sItems.length == 1) {
            self.selectedTP = self.sItems[0]
          }
        }, function() {});
      },
      loadVendors(query) {
        let self = this;
        piincHttp.get('vendors', { params:
          {
            client: this.getClient.slug,
            parent: this.getClient.parent ? 1 : undefined,
            has_contract: 1,
            per_page: 100,
            search: query ? query : undefined
          }
        }).then(function(response) {
          self.vendors = response.data.items
        }, function() {});
      },
    },
    created () {
      this.activity = this.object;
      if (this.activity && this.activity.id) {
        this.showTable = true;
        this.loadTasks('update_third_party_receivers');
        this.loadThirdParties();
      }

      this.loadGuides('update_third_party_receivers');
      this.loadGuides('copy_dataflow');
      this.loadGuides('data_mapping');

    }
  }
</script>
